export default __webpack_public_path__ + "static/media/tutum.9ad4ae68.svg";